import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
const CourseUploadForm = () => {
	const toolKitTemplate = {
		name: "",
		link: "",
		description: "",
	};
	const [toolkits, setToolKits] = useState([toolKitTemplate]);
	const addToolKits = () => {
		setToolKits([...toolkits, toolKitTemplate]);
	};
	const removeToolKits = (index) => {
		const filterdToolKits = [...toolkits];
		filterdToolKits.splice(index, 1);
		setToolKits(filterdToolKits);
	};

	const generalvideoTemplate = {
		name: "",
		link: "",
		description: "",
	};
	const [generalVideos, setGeneralVideos] = useState([generalvideoTemplate]);
	const addgeneralVideos = () => {
		setGeneralVideos([...generalVideos, generalvideoTemplate]);
	};
	const removegeneralVideos = (index) => {
		const filterdgeneralVideos = [...generalVideos];
		filterdgeneralVideos.splice(index, 1);
		setGeneralVideos(filterdgeneralVideos);
	};

	const testLinksTemplate = {
		name: "",
		link: "",
		description: "",
	};
	const [testLinks, setTestLinks] = useState([testLinksTemplate]);
	const addtestLinks = () => {
		setTestLinks([...testLinks, testLinksTemplate]);
	};
	const removetestLinks = (index) => {
		const filterdtestLinks = [...testLinks];
		filterdtestLinks.splice(index, 1);
		setTestLinks(filterdtestLinks);
	};

	const videosTemplate = {
		name: "",
		link: "",
		description: "",
	};
	const [videos, setVideos] = useState([videosTemplate]);
	const addVideos = () => {
		setVideos([...videos, videosTemplate]);
	};
	const removeVideos = (index) => {
		const filterdvideos = [...videos];
		filterdvideos.splice(index, 1);
		setVideos(filterdvideos);
	};
	const knowledgeCardsTemplate = {
		name: "",
		link: "",
		section: "",
		bigHeading: "",
		photo: "",
	};

	const [knowledgeCards, setKnowledgeCards] = useState([
		knowledgeCardsTemplate,
	]);
	const addknowledgeCards = () => {
		setKnowledgeCards([...knowledgeCards, knowledgeCardsTemplate]);
	};
	const removeknowledgeCards = (index) => {
		const filterdknowledgeCards = [...knowledgeCards];
		filterdknowledgeCards.splice(index, 1);
		setKnowledgeCards(filterdknowledgeCards);
	};

	const [name, setName] = useState("");
	const [mentor, setMentor] = useState("");
	const [description, setDescription] = useState("");
	const [image, setImage] = useState("");

	const learningTemplate = "";
	const [learning, setLearning] = useState([learningTemplate]);
	const addlearning = () => {
		setLearning([...learning, learningTemplate]);
	};
	const removelearning = (index) => {
		const filterdlearning = [...learning];
		filterdlearning.splice(index, 1);
		setLearning(filterdlearning);
	};
	// this is final json to be send to the backend.
	// const FormatToolkits=(e)=>{
	//   e.preventDefault();
	//   const {id,value}=e.target;
	//   if(id=="name"){
	//     setToolKits({name:value,link:""})
	//   }
	//   if(id=="link"){
	//     setToolKits({name:"",link:value})
	//   }
	// }

	// var array = [];
	// const handleSubmit = () => {
	//   array = learning.replace(/(\r\n|\n|\r)/gm, ",");
	//   array = array.split(",");
	//   console.log(array);
	//   const data = {
	//     name: name,
	//     description: description,
	//     toolkits: toolkits,
	//     generalVideos: generalVideos,
	//     testLinks: testLinks,
	//     videos: videos,
	//     knowledgeCards: knowledgeCards,
	//     mentor: mentor,
	//     image: image,
	//     learning: array,
	//   };
	//   console.log("Data from course upload", data);
	// fetch(BASE_URL+"/postCourse",{
	//   method:"POST",
	//   headers:{"Content-Type":"application/json"},
	//   body:JSON.stringfy()
	// })
	// };
	return (
		<div
			className="container border shadow"
			style={{
				maxHeight: "95vh",
				overflowY: "scroll",
				scrollBehavior: "smooth",
			}}
		>
			<div className=" mt-4">
				<h1
					className="border rounded"
					style={{
						fontSize: "2rem",
						color: "#185adb",
						fontWeight: "700",
						textAlign: "center",
					}}
				>
					Upload Course Form
				</h1>

				<div class="form-row ">
					<div class="form-group ">
						<label for="name">Name</label>
						<input
							type="text"
							class="form-control"
							id="name"
							placeholder="name..."
							style={{ width: "96%" }}
							onChange={(e) => {
								setName(e.target.value);
							}}
						/>
					</div>
					<div class="form-group ">
						<label for="mentor">Mentor</label>
						<input
							type="text"
							class="form-control"
							id="mentor"
							placeholder="Mentor..."
							style={{ width: "96%" }}
							onChange={(e) => {
								setMentor(e.target.value);
							}}
						/>
					</div>
					<div class="form-group ">
						<label for="image">Image</label>
						<input
							type="text"
							class="form-control"
							id="image"
							placeholder="Image..."
							style={{ width: "96%" }}
							onChange={(e) => {
								setImage(e.target.value);
							}}
						/>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label for="description">Description</label>
						<textarea
							style={{ width: "96%" }}
							class="form-control"
							id="description"
							rows="3"
							onChange={(e) => {
								setDescription(e.target.value);
							}}
						></textarea>
					</div>
					<div class="form-group mt-4 ">
						<label for="inputState">
							Learning{" "}
							<button
								class="btn btn-primary"
								onClick={addlearning}
							>
								add more
							</button>
						</label>
						{learning.map((learn, i) => {
							return (
								<div className="mt-4">
									<input
										type="text"
										id="inputState"
										style={{ width: "96%" }}
										class="form-control"
										onChange={(e) => {
											setLearning(e.target.value);
										}}
									></input>{" "}
									<button
										class="btn btn-sm btn-danger"
										onClick={() => removelearning(i)}
									>
										remove
									</button>
								</div>
							);
						})}
					</div>
					<br />
					<hr />
					<br />
					<div class="form-group mt-4">
						<label for="name">
							ToolKits{" "}
							<button
								class="btn btn-primary"
								onClick={addToolKits}
							>
								add more
							</button>
						</label>
						{toolkits.map((toolkit, i) => {
							return (
								<div
									class="d-flex flex-row mt-4 flex-wrap"
									style={{ width: "96%" }}
								>
									<div>
										<label for="name">Name</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="link">Link</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="description">
											Description
										</label>
										<textarea
											style={{
												width: "100%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="description"
											rows="3"
											onChange={(e) => {
												setDescription(e.target.value);
											}}
										></textarea>

										<button
											class="btn btn-sm btn-danger"
											onClick={() => removeToolKits(i)}
										>
											remove
										</button>
									</div>
								</div>
							);
						})}
					</div>

					<div class="form-group mt-4">
						<label for="name">
							General Videos{" "}
							<button
								class="btn btn-primary"
								onClick={addgeneralVideos}
							>
								add more
							</button>
						</label>
						{generalVideos.map((generalVideo, i) => {
							return (
								<div
									class="d-flex flex-row mt-4 flex-wrap"
									style={{ width: "96%" }}
								>
									<div>
										<label for="name">Name</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="link">Link</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="description">
											Description
										</label>
										<textarea
											style={{
												width: "100%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="description"
											rows="3"
											onChange={(e) => {
												setDescription(e.target.value);
											}}
										></textarea>

										<button
											class="btn btn-sm btn-danger"
											onClick={() =>
												removegeneralVideos(i)
											}
										>
											remove
										</button>
									</div>
								</div>
							);
						})}
					</div>

					<div class="form-group mt-4">
						<label for="name">
							Test Link{" "}
							<button
								class="btn btn-primary"
								onClick={addtestLinks}
							>
								add more
							</button>
						</label>
						{testLinks.map((testLink, i) => {
							return (
								<div
									class="d-flex flex-row mt-4 flex-wrap"
									style={{ width: "96%" }}
								>
									<div>
										<label for="name">Name</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="link">Link</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="description">
											Description
										</label>
										<textarea
											style={{
												width: "100%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="description"
											rows="3"
											onChange={(e) => {
												setDescription(e.target.value);
											}}
										></textarea>
										<button
											class="btn btn-sm btn-danger"
											onClick={() => removetestLinks(i)}
										>
											remove
										</button>
									</div>
								</div>
							);
						})}
					</div>

					<div class="form-group mt-4">
						<label for="name">
							Videos{" "}
							<button class="btn btn-primary" onClick={addVideos}>
								add more
							</button>
						</label>
						{videos.map((video, i) => {
							return (
								<div
									class="d-flex flex-row mt-4 flex-wrap"
									style={{ width: "96%" }}
								>
									<div>
										<label for="name">Name</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="link">Link</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="section">Section</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="section"
										></input>
									</div>
									<div>
										<label for="bigHeading">
											Big Heading
										</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="bigHeading"
										></input>
									</div>
									<div>
										<label for="description">
											Description
										</label>
										<textarea
											style={{
												width: "100%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="description"
											rows="3"
											onChange={(e) => {
												setDescription(e.target.value);
											}}
										></textarea>
										<button
											class="btn btn-sm btn-danger"
											onClick={() => removeVideos(i)}
										>
											remove
										</button>
									</div>
								</div>
							);
						})}
					</div>

					<div class="form-group mt-4">
						<label for="name">
							Knowledge Cards{" "}
							<button
								class="btn btn-primary"
								onClick={addknowledgeCards}
							>
								add more
							</button>
						</label>
						{knowledgeCards.map((video, i) => {
							return (
								<div
									class="d-flex flex-row mt-4 flex-wrap"
									style={{ width: "96%" }}
								>
									<div>
										<label for="name">Name</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="link">Link</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="name"
										></input>
									</div>
									<div>
										<label for="section">Section</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="section"
										></input>
									</div>
									<div>
										<label for="bigHeading">
											Big Heading
										</label>
										<input
											key={i}
											type="text"
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="bigHeading"
										></input>
									</div>
									<div>
										<label for="photo">Photo</label>
										<input
											style={{
												width: "98%",
												margin: "1vh 1vw",
											}}
											class="form-control"
											id="description"
											onChange={(e) => {
												setDescription(e.target.value);
											}}
										></input>
										<button
											class="btn btn-sm btn-danger"
											onClick={() =>
												removeknowledgeCards(i)
											}
										>
											remove
										</button>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div>
				<button
					style={{ width: "96%" }}
					class="btn btn-primary btn-lg rounded-pill btn-block mt-4"
					// onClick={() => {
					//   handleSubmit();
					// }}
				>
					Submit
				</button>
			</div>
		</div>
	);
};
export default CourseUploadForm;
